import { ErrorType } from './enums';

export class ErrorMessage {
  lineNumber?: number;
  message: string;
  simpleMessage?: string;
  time: Date;
  type: ErrorType;
  errorName: string;

  constructor(message: string, time: Date, type: ErrorType, errorName: string, lineNumber: number = null, simpleMessage: string = null) {
    this.message = message;
    this.simpleMessage = simpleMessage;
    this.time = time;
    this.type = type;
    this.errorName = errorName;
    this.lineNumber = lineNumber;
  }
}
